<template>
    <div class="explanation-container">
        <div class="full-width">
            <div class="customer-action-card">
                <div class="d-flex align-center justify-center flex-wrap gap-2 mb-2">
                    <h4 class="text-h6 primary--text">
                        New Wine Release Campaign
                    </h4>
                </div>
                <p class="mb-1"><strong>Wine:</strong> {{ wine_data.name }}</p>
                <p class="mb-1"><strong>Club Price:</strong> ${{ wine_data.club_price.toFixed(2) }} <span class="regular-price">(Reg. ${{ wine_data.regular_price.toFixed(2) }})</span></p>
            </div>
        </div>

        <div>
            <h3 class="text-h5 text-left mb-3">Here's what's happening ...</h3>
            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text" v-html="point"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExplainerInitialMessage',

    props: {
        customer_data: {
            type: Object,
            required: true
        },
        wine_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        explanationPoints() {
            return [
                `${this.customer_data.first_name} is a ${this.customer_data.club_tier} member who has opted in to receive promotional text messages from Barrel Creek Vineyards`,
                `Using RedChirp, Barrel Creek Vineyards sends a personalized SMS announcing the new ${this.wine_data.name} release with a link to learn more`,
                `The message content contains <strong>no direct promotion of alcohol</strong>, instead delegating to the landing page for more detailed information`
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }

    .scenario-context {
        max-width: 500px;
        margin: 0 auto;

        @media (min-width: 900px) {
            margin: 0;
            max-width: none;
        }
    }

    .customer-action-card {
        background: #f8f9fa;
        border: 2px solid #e9ecef;
        border-radius: 12px;
        padding: 1.5rem;
        text-align: center;

        .regular-price {
            color: #999;
            font-size: 0.85rem;
        }
    }
}
</style>
